import { render, staticRenderFns } from "./Endorsements.vue?vue&type=template&id=7d97dd2a&scoped=true&"
import script from "./Endorsements.vue?vue&type=script&lang=js&"
export * from "./Endorsements.vue?vue&type=script&lang=js&"
import style0 from "./Endorsements.vue?vue&type=style&index=0&id=7d97dd2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d97dd2a",
  null
  
)

export default component.exports